import {Module} from "vuex-smart-module";
import RootState from "@/store/modules/root-state";
import RootGetters from "@/store/modules/root-getters";
import RootMutations from "@/store/modules/root-mutations";
import RootActions from "@/store/modules/root-actions";
import building from "@/store/modules/building";
import contract from "@/store/modules/contract";
import job from "@/store/modules/job";
import meter from "@/store/modules/meter";
import product from "@/store/modules/product";
import accessControl from "@/store/modules/access-control";
import unit from "@/store/modules/unit";
import unitCheck from "@/store/modules/unit-check";
import user from "@/store/modules/user";
import utilityCounter from "@/store/modules/utility-counter";
import qrServer from "@/store/modules/qr-server";
import warehouseShop from "@/store/modules/warehouse-shop";
import warehouseAdmin from "@/store/modules/warehouse-admin";

const modules = {
    accessControl,
    building,
    contract,
    job,
    meter,
    product,
    qrServer,
    unit,
    unitCheck,
    user,
    utilityCounter,
    warehouseShop,
    warehouseAdmin
} as const;

export default new Module({
    state: RootState,
    getters: RootGetters,
    mutations: RootMutations,
    actions: RootActions,
    modules
});

export type ModuleKey = keyof typeof modules;

export const DEFAULT_REQUIRED_MODULES: ModuleKey[] = [
    "building",
    "user"
];
